import judoGi from '../assets/products/judu-gi.jpeg';
import judoGi1 from '../assets/products/judu-gi1.jpeg';
import mma1 from '../assets/products/mma-shorts/mma-shorts.jpeg';
import mma2 from '../assets/products/mma-shorts/mma-shorts1.jpeg';
import mma3 from '../assets/products/mma-shorts/mma-shorts2.jpeg';
import mma4 from '../assets/products/mma-shorts/mma-shorts3.jpeg';
import rash1 from '../assets/products/rash-guards/rash-guard1.jpeg';
import rash2 from '../assets/products/rash-guards/rash-guard2.jpeg';
import rash3 from '../assets/products/rash-guards/rash-guard3.jpeg';
import rash4 from '../assets/products/rash-guards/rash-guard4.jpeg';
import spats1 from '../assets/products/spats/spats1.jpeg';
import spats2 from '../assets/products/spats/spats2.jpeg';
import spats3 from '../assets/products/spats/spats3.jpeg';
import spats4 from '../assets/products/spats/spats4.jpeg';
import sportsBra1 from '../assets/products/sports-bra/sports-bra1.jpeg';
import sportsBra2 from '../assets/products/sports-bra/sports-bra2.jpeg';
import sportsBra3 from '../assets/products/sports-bra/sports-bra3.jpeg';
import sportsBra4 from '../assets/products/sports-bra/sports-bra4.jpeg';
import belt1 from '../assets/products/belts/belt1.jpeg';
import patch1 from '../assets/products/patches/patch1.jpeg';
import patch2 from '../assets/products/patches/patch2.jpeg';
import patch3 from '../assets/products/patches/patch3.jpeg';
import patch4 from '../assets/products/patches/patch4.jpeg';
import hoodie1 from '../assets/products/sports-hoodies/sports-hoodies1.jpeg';
import hoodie2 from '../assets/products/sports-hoodies/sports-hoodies2.jpeg';
import hoodie3 from '../assets/products/sports-hoodies/sports-hoodies3.jpeg';
import hoodie4 from '../assets/products/sports-hoodies/sports-hoodies4.jpeg';
import hoodie5 from '../assets/products/sports-hoodies/sports-hoodies5.jpeg';
import hoodie6 from '../assets/products/sports-hoodies/sports-hoodies6.jpeg';

/* ══════════════════════════════════════════════════
   1. directCategories
══════════════════════════════════════════════════ */
export const directCategories = {
  'mma-shorts': {
    title: 'MMA Shorts',
    tagline: 'Fight Ready · Custom Sublimation',
    img: mma1,
    color: '#5b9bd5'
  },
  'belts': {                         
    title: 'Belts',
    tagline: 'All Ranks · Judo & BJJ',
    img: belt1,
    color: '#c9a227'
  },
  'rash-guards': {
    title: 'Rash Guards',
    tagline: 'Full & Short Sleeve · IBJJF Legal',
    img: rash2,
    color: '#9b59b6'
  },
  'spats': {
    title: 'Spats',
    tagline: '4-Way Stretch · Full Sublimation',
    img: spats1,
    color: '#c9a227'
  },
  'sports-bra': {
    title: 'Sports Bra',
    tagline: "Women's · High Support",
    img: sportsBra3,
    color: '#e07b5c'
  },
  'sports-hoodies': {
    title: 'Sports Hoodies',
    tagline: 'Custom · Full Sublimation · All Sizes',
    img: hoodie5,
    color: '#4caf7d'
  },
  'patches': {
    title: 'Separate Patches',
    tagline: 'Embroidered · Woven · PVC',
    img: patch1,
    color: '#c9a227'
  },
};

/* ══════════════════════════════════════════════════
   2. uniformCategories
══════════════════════════════════════════════════ */
export const uniformCategories = [
  {
    slug: 'judo-gi',
    title: 'Judo Gi',
    desc: 'Competition-grade Judo Gis in Medium, DC and Touchio fabric weights.',
    img: judoGi,
    color: '#c9a227',
  },
  {
    slug: 'jiujitsu-gi',
    title: 'Jiujitsu Gi',
    desc: 'Pearl Weave, Gold Weave, Crystal Weave, Diamond Weave and Honey Comb Gis.',
    img: judoGi1,
    color: '#e07b5c',
  },
];

/* ══════════════════════════════════════════════════
   3. beltCategories — EK HI ENTRY
══════════════════════════════════════════════════ */
export const beltCategories = [
  {
    slug: 'belts',
    title: 'Belts',
    tagline: 'All Ranks · Judo & BJJ',
    desc: 'Judo and Jiujitsu belts in all rank colors. IJF & IBJJF approved widths.',
    img: belt1,
    color: '#c9a227',
  },
];

/* ══════════════════════════════════════════════════
   4. productsByCategory
══════════════════════════════════════════════════ */
export const productsByCategory = {

  'judo-gi': [
    {
      id: 1,
      name: 'Judo Gi',
      tag: 'Tournament Grade',
      fabric: 'Touchio Cotton',
      gsm: '750 GSM',
      use: 'IJF Competition',
      moq: '10 pcs',
      images: [judoGi, judoGi1],
      desc: 'Our heaviest and most prestigious Judo Gi.',
      details: [
        '750 GSM Touchio fabric',
        '100% Cotton or CVC blend',
        'IJF-approved cut',
      ],
      colors: ['Black', 'Blue'],
    },
  ],

  'jiujitsu-gi': [
    {
      id: 4,
      name: 'BJJ Gi Collection',
      tag: 'Bestseller & Classic',
      images: [judoGi, judoGi1],
      fabric: 'Pearl + Gold Weave',
      gsm: '350 / 450 / 550 GSM',
      use: 'Competition & Training',
      moq: '10 pcs',
      desc: 'Premium BJJ Gi collection including Pearl Weave & Gold Weave.',
      details: [
        'Pearl Weave + Gold Weave options',
        '350 / 450 / 550 GSM available',
        'IBJJF legal colors',
        'Reinforced collar & seams',
        'Custom patches',
        'Ripstop or Canvas pants',
      ],
      colors: ['Blue', 'Black'],
    },
  ],

  //  BELTS — EK HI ENTRY
  'belts': [
    {
      id: 13,
      name: 'Belts — Judo & BJJ All Ranks',
      tag: 'All Ranks',
      fabric: 'Cotton / Heavy Cotton',
      gsm: 'Standard & 350 GSM',
      use: 'Judo & BJJ All Ranks',
      moq: '50 pcs',
      images: [belt1],
      desc: 'Judo and BJJ belts in all rank colors. Available in standard and 350 GSM heavy cotton. IJF & IBJJF approved widths.',
      details: [
        'Judo & BJJ belts available',
        'All Kyu & Dan rank colors',
        'Standard & 350 GSM options',
        'IJF & IBJJF approved widths',
        'Stripe tape tip (BJJ)',
        'Machine washable',
        'Colorfastness guaranteed',
        'Custom embroidery available',
      ],
      colors: ['White', 'Yellow', 'Orange', 'Green', 'Blue', 'Purple', 'Brown', 'Black', 'Red/White', 'Red/Black', 'Red'],
    },
  ],

  'mma-shorts': [
    {
      id: 17,
      name: 'MMA Fight Shorts — Satin',
      tag: 'Fight Ready',
      fabric: 'Satin Polyester',
      gsm: '—',
      use: 'MMA & Muay Thai',
      moq: '20 pcs',
      images: [mma1, mma2, mma3, mma4],
      desc: 'Professional satin MMA shorts with full sublimation printing and reinforced stitching.',
      details: [
        '100% satin polyester',
        'Full sublimation',
        'Velcro + drawstring',
        'Stretch side panels',
        'No Gi legal',
      ],
      colors: ['All Custom Colors'],
    },
  ],

  'rash-guards': [
    {
      id: 19,
      name: 'Rash Guards — Full & Short Sleeve',
      tag: 'IBJJF Legal',
      fabric: '85% Poly / 15% Spandex',
      gsm: '—',
      use: 'BJJ No Gi & MMA',
      moq: '20 pcs',
      images: [rash1, rash2, rash3, rash4],
      desc: 'IBJJF-legal rash guards in full sleeve and short sleeve variants. Flat-lock seams, UPF 50+ protection, full custom sublimation.',
      details: [
        'Full & Short Sleeve options',
        '85% Poly / 15% Spandex blend',
        'UPF 50+ sun protection',
        'Flat-lock seams prevent chafing',
        'IBJJF competition legal',
        'Full sublimation printing',
        'Anti-odor treatment available',
        'Sizes XS–4XL',
      ],
      colors: ['All Custom Colors'],
    },
  ],

  'spats': [
    {
      id: 23,
      name: 'Spats — Full & 3/4 Length',
      tag: 'No Gi',
      fabric: 'Spandex Blend',
      gsm: '—',
      use: 'BJJ No Gi & MMA',
      moq: '20 pcs',
      images: [spats1, spats2, spats3, spats4],
      desc: 'Full-length and 3/4 length grappling spats with 4-way stretch and full sublimation printing.',
      details: [
        'Full & 3/4 length options',
        '4-way stretch spandex',
        'High compression waistband',
        'Flat-lock seams',
        'Full sublimation printing',
        'Anti-ride-up design',
        'Moisture-wicking fabric',
        'Sizes XS–4XL',
      ],
      colors: ['All Custom Colors'],
    },
  ],

  'sports-bra': [
    {
      id: 25,
      name: 'Sports Bra — Training & Compression',
      tag: "Women's",
      fabric: 'Spandex / Poly',
      gsm: '—',
      use: 'Training & Competition',
      moq: '20 pcs',
      images: [sportsBra2, sportsBra1, sportsBra3, sportsBra4],
      desc: 'High-support sports bras for martial arts training and competition. Available in training and compression variants with full custom sublimation.',
      details: [
        'Training & Compression options',
        'High support design',
        'Removable padding available',
        '4-way stretch fabric',
        'Racerback cut option',
        'Full sublimation printing',
        'Anti-slip underband',
        'Sizes XS–XXL',
      ],
      colors: ['All Custom Colors'],
    },
  ],

  //  SPORTS HOODIES — KEYCHAIN HATA KE YE ADD KIYA
  'sports-hoodies': [
    {
      id: 33,
      name: 'Sports Hoodies — Custom',
      tag: 'Custom',
      fabric: 'Fleece / Poly Blend',
      gsm: '—',
      use: 'Training & Casual Wear',
      moq: '20 pcs',
      images: [hoodie1, hoodie2, hoodie3, hoodie4, hoodie5, hoodie6],
      desc: 'Custom sports hoodies with full sublimation or embroidery. Perfect for martial arts academies, sports clubs and team branding.',
      details: [
        'Full sublimation or embroidery',
        'Fleece & poly blend options',
        'Kangaroo pocket design',
        'Adjustable drawstring hood',
        'Ribbed cuffs & hem',
        'Academy & team branding',
        'All custom colors',
        'Sizes XS–4XL',
      ],
      colors: ['All Custom Colors'],
    },
  ],

  // PATCHES — 1 CARD, 4 IMAGES
'patches': [
  {
    id: 29,
    name: 'Patches — Embroidered, Woven & PVC',
    tag: 'All Types',
    fabric: 'Twill / Thread / PVC',
    gsm: '—',
    use: 'Gi & Apparel Branding',
    moq: '50 pcs',
    images: [patch1, patch2, patch3, patch4],
    desc: 'All patch types available — embroidered, woven, sublimation and rubber/PVC. Multiple backing options for Gi, rash guards and gear bags.',
    details: [
      'Embroidered, Woven, Sublimation & PVC options',
      'High-density embroidery up to 15 colors',
      'Fine woven detail for complex logos',
      'Full-color sublimation available',
      '3D raised PVC / rubber patches',
      'Merrow or laser-cut edges',
      'Iron-on / sew-on / velcro backing',
      'Min. 50 units',
    ],
    colors: ['Full Custom'],
  },
],
};